import {Box, Flex, Tag} from 'exsportia-components'
import {FC, ReactElement} from 'react'

import {SubscriptionBooking} from '../../../api/subscription-bookings/types'
import {PreviewCard} from '../../../ui/components/preview-card/preview-card'
import {isNilOrEmpty} from '../../../utils/logic'

export type SubscriptionBookingCardWithChipsProps = {
  booking: SubscriptionBooking
  subtitle: ReactElement
  chips?: {
    text: string
    color: string
    textColor: string
  }[]
}

const Chips: FC<{chips: SubscriptionBookingCardWithChipsProps['chips']}> = ({chips}) => {
  if (isNilOrEmpty(chips)) {
    return null
  }
  return (
    <>
      {chips.map(({text, color, textColor}, i) => (
        <Tag
          key={i}
          text={text}
          settings={{bg: color, iconWithText: {text: {color: textColor}}}}
        />
      ))}
    </>
  )
}

export const SubscriptionBookingCardWithChips: FC<SubscriptionBookingCardWithChipsProps> = ({
  booking,
  subtitle,
  chips = [],
}) => {
  return (
    <Box width={'100%'}>
      <Flex
        height='0'
        overflow='visible'
        position={'relative'}
        zIndex={1}
        flexWrap='wrap'
        gap='8px'
        top='12px'
        left='12px'
      >
        <Chips chips={chips} />
      </Flex>
      <PreviewCard
        title={booking.membershipName}
        subtitle={subtitle}
        image={booking.logo.secure_url}
      />
    </Box>
  )
}
